// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ClearinghouseTransactionType,
    ClearinghouseTransactionTypeFromJSON,
    ClearinghouseTransactionTypeToJSON,
    Revision,
    RevisionFromJSON,
    RevisionToJSON,
    SupportClearinghouse,
    SupportClearinghouseFromJSON,
    SupportClearinghouseToJSON,
    SupportPayer,
    SupportPayerFromJSON,
    SupportPayerToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportClearinghousePayer
 */
export interface SupportClearinghousePayer {
    /**
     * The id of the clearinghouse payer
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClearinghousePayer
     */
    id?: string;
    /**
     * The external id the clearinghouse has assigned the payer
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClearinghousePayer
     */
    externalId?: string;
    /**
     * The eligibility check will not attempt to flip the associated claim to a differently mapped payer
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportClearinghousePayer
     */
    skipEligibilityMismatchCorrection?: boolean;
    /**
     * The eligibliity check will use the claim rendering provider instead of the billing provider in the 270 request
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportClearinghousePayer
     */
    useRenderingProviderInEligibilityCheck?: boolean;
    /**
     * Whether the clearinghouse payer connection supports electronic claim submission for non-primary claims
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportClearinghousePayer
     */
    nonPrimaryElectronicClaimSubmission?: boolean;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ClearinghouseTransactionType>}
     * @memberof SupportClearinghousePayer
     */
    transactions?: Array<ClearinghouseTransactionType>;
    /**
     * 
     * OpenAPI data type: {SupportClearinghouse}
     * @type {SupportClearinghouse}
     * @memberof SupportClearinghousePayer
     */
    clearinghouse?: SupportClearinghouse;
    /**
     * 
     * OpenAPI data type: {SupportPayer}
     * @type {SupportPayer}
     * @memberof SupportClearinghousePayer
     */
    payer?: SupportPayer;
    /**
     * User markable as starred
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportClearinghousePayer
     */
    starred?: boolean;
    /**
     * The status of the clearinghouse payer
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportClearinghousePayer
     */
    active?: boolean;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClearinghousePayer
     */
    created?: string;
    /**
     * The revision group
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClearinghousePayer
     */
    groupId?: string;
    /**
     * Revisions within the resource group
     * OpenAPI data type: {array}
     * @type {Array<Revision>}
     * @memberof SupportClearinghousePayer
     */
    revisions?: Array<Revision>;
}

export function SupportClearinghousePayerFromJSON(json: any): SupportClearinghousePayer {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
            'skipEligibilityMismatchCorrection': !exists(json, 'skipEligibilityMismatchCorrection') ? undefined : json['skipEligibilityMismatchCorrection'],
            'useRenderingProviderInEligibilityCheck': !exists(json, 'useRenderingProviderInEligibilityCheck') ? undefined : json['useRenderingProviderInEligibilityCheck'],
            'nonPrimaryElectronicClaimSubmission': !exists(json, 'nonPrimaryElectronicClaimSubmission') ? undefined : json['nonPrimaryElectronicClaimSubmission'],
            'transactions': !exists(json, 'transactions') ? undefined : (json['transactions'] as Array<any>).map(ClearinghouseTransactionTypeFromJSON),
            'clearinghouse': !exists(json, 'clearinghouse') ? undefined : SupportClearinghouseFromJSON(json['clearinghouse']),
            'payer': !exists(json, 'payer') ? undefined : SupportPayerFromJSON(json['payer']),
            'starred': !exists(json, 'starred') ? undefined : json['starred'],
            'active': !exists(json, 'active') ? undefined : json['active'],
            'created': !exists(json, 'created') ? undefined : json['created'],
            'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
            'revisions': !exists(json, 'revisions') ? undefined : (json['revisions'] as Array<any>).map(RevisionFromJSON),
    };

}

export function SupportClearinghousePayerToForm(value?: SupportClearinghousePayer): any {
    let jsonVal = SupportClearinghousePayerToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportClearinghousePayerToJSON(value?: SupportClearinghousePayer): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'externalId': cleanupBlankValuesForBackend(value.externalId),
            'skipEligibilityMismatchCorrection': cleanupBlankValuesForBackend(value.skipEligibilityMismatchCorrection),
            'useRenderingProviderInEligibilityCheck': cleanupBlankValuesForBackend(value.useRenderingProviderInEligibilityCheck),
            'nonPrimaryElectronicClaimSubmission': cleanupBlankValuesForBackend(value.nonPrimaryElectronicClaimSubmission),
            'transactions': (value.transactions === undefined || value.transactions === null) ? undefined : (value.transactions as Array<any>).map(ClearinghouseTransactionTypeToJSON),
            'clearinghouse': SupportClearinghouseToJSON(value.clearinghouse),
            'payer': SupportPayerToJSON(value.payer),
            'starred': cleanupBlankValuesForBackend(value.starred),
            'active': cleanupBlankValuesForBackend(value.active),
            'created': cleanupBlankValuesForBackend(value.created),
            'groupId': cleanupBlankValuesForBackend(value.groupId),
            'revisions': (value.revisions === undefined || value.revisions === null) ? undefined : (value.revisions as Array<any>).map(RevisionToJSON),
    };
}


